export const sortByName = ( list ) => {
	return list.sort( ( a, b ) => {
		let aName = a.givenName + ' ' + a.surname;
		let bName = b.givenName + ' ' + b.surname;

		return aName > bName;
	} );
};